//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesField from '../../components/File/FilesField.vue'
import FilesGroup from '../../components/File/FilesGroup'

export default {
  components: { FilesField },
  props: {
    textLabel: {
      type: String,
      default: 'Текст'
    },
    title: {
      type: String,
      default: ''
    },
    propName: {
      type: String,
      default: ''
    },
    employeeName: {
      type: String,
      default: ''
    },
    reportId: {
      type: Number,
      default: 0
    },
    isTextRequired: {
      type: Boolean,
      default: false
    },
    mediaShown: {
      type: Boolean,
      default: true
    },
    initialParams: {
      type: Object,
      default: null
    },
    validateChangeInitialParams: {
      type: Boolean,
      default: false
    },
    filesGroupToCheckForIgnoreDuplicate: {
      type: Object,
      default: null
    },
    withRequestToResponsible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      requestToResponsible: false,
      text: this.initialParams ? this.initialParams.text : '',
      commentPhotos: new FilesGroup({
        categoryKey: 'workQualityReview',
        documentType: 'workQualityReview',
        sourceConfig: {
          objectId: this.reportId,
          removeURL: '/service/delta/document/deleteFromObject'
        }
      }),
      commentDocuments: new FilesGroup({
        categoryKey: 'workQualityReview',
        documentType: 'workQualityReview',
        sourceConfig: {
          objectId: this.reportId,
          removeURL: '/service/delta/document/deleteFromObject'
        }
      })
    }
  },
  watch: {
    initialParams: {
      handler (value) {
        if (value) {
          this.text = value.text
          const photosFiles = this.getFiles(value.photos)
          photosFiles.forEach(file => {
            this.commentPhotos.pushFile(file)
          })
          const documentsFiles = this.getFiles(value.files)
          documentsFiles.forEach(file => {
            this.commentDocuments.pushFile(file)
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    getFiles: function (ids) {
      if (ids) {
        return ids.map(id => {
          return {
            url: '/service/fileobj/read/' + id,
            smallUrl: '/service/delta/document/thumbnail/' + id + '/140/140',
            name: 'Качество работ на УДС' + '-' + id,
            id: id
          }
        })
      } else {
        return []
      }
    },
    getSuccessFileIds (files) {
      const filesLoad = files.filter(item => item.status !== 'rejected') || []
      const successfileIds = filesLoad.map(item => {
        return item.value.data.id
      })
      return successfileIds
    },
    uploadFiles: async function () {
      try {
        const photos = await this.commentPhotos.uploadFiles({
          notify: true,
          target: this
        })
        let photosIds = []
        if (photos) {
          photosIds = this.getSuccessFileIds(photos.results)
        }
        const documents = await this.commentDocuments.uploadFiles({
          notify: true,
          target: this
        })
        let documentsIds = []
        if (documents) {
          documentsIds = this.getSuccessFileIds(documents.results)
        }
        return {
          photosIds,
          documentsIds
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    validate: function () {
      if (this.initialParams) {
        if (this.validateChangeInitialParams && this.text === this.initialParams.text) {
          this.$q.notify({
            type: 'negative',
            message: 'Необходимо изменить текст',
            progress: true,
            timeout: 8000
          })
          return false
        }
      }
      return this.$refs.text.validate()
    },
    onContinue: function () {
      if (!this.validate()) {
        return
      }

      this.loading = true
      if (this.mediaShown) {
        this.uploadFiles()
          .then(result => {
            if (result) {
              this.$emit('continue', { text: this.text, photosIds: result.photosIds, documentsIds: result.documentsIds, requestToResponsible: this.requestToResponsible })
            }
          }).catch(result => {
            if (result.message) {
              this.$q.notify({
                type: 'negative',
                message: result.message,
                progress: true,
                timeout: 8000
              })
            }
          }).finally(() => {
            // this.$emit('continue', { text: this.text });
            this.loading = false
          })
      } else {
        this.$emit('continue', { text: this.text })
      }
    },
    onCancel () {
      this.$emit('cancel')
    }
  }
}
